"use strict";
export { Input, InputPropsProvider } from './input.js';
